var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.792,
    height: 89.688,
    viewBox: "0 0 87.792 89.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sun",
    transform: "translate(7592.947 3637.08)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(-7578 -3621)",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M292.585-141.533a2.618,2.618,0,0,0-1.73,1.277c-.34.623-.355.76-.355,4.972s.016,4.348.355,4.972a2.77,2.77,0,0,0,4.7,0c.34-.623.355-.76.355-4.972s-.016-4.348-.355-4.972A2.829,2.829,0,0,0,292.585-141.533Z",
    transform: "matrix(-0.999, 0.035, -0.035, -0.999, -7261.198, -3776.152)",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M292.585-141.533a2.618,2.618,0,0,0-1.73,1.277c-.34.623-.355.76-.355,4.972s.016,4.348.355,4.972a2.77,2.77,0,0,0,4.7,0c.34-.623.355-.76.355-4.972s-.016-4.348-.355-4.972A2.829,2.829,0,0,0,292.585-141.533Z",
    transform: "matrix(-0.602, -0.799, 0.799, -0.602, -7236.481, -3466.27)",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M292.585-141.533a2.618,2.618,0,0,0-1.73,1.277c-.34.623-.355.76-.355,4.972s.016,4.348.355,4.972a2.77,2.77,0,0,0,4.7,0c.34-.623.355-.76.355-4.972s-.016-4.348-.355-4.972A2.829,2.829,0,0,0,292.585-141.533Z",
    transform: "translate(-7641.674 -3886.21) rotate(91)",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M292.585-141.533a2.618,2.618,0,0,0-1.73,1.277c-.34.623-.355.76-.355,4.972s.016,4.348.355,4.972a2.77,2.77,0,0,0,4.7,0c.34-.623.355-.76.355-4.972s-.016-4.348-.355-4.972A2.829,2.829,0,0,0,292.585-141.533Z",
    transform: "translate(-7383.37 -3854.812) rotate(140)",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M292.585-141.533a2.618,2.618,0,0,0-1.73,1.277c-.34.623-.355.76-.355,4.972s.016,4.348.355,4.972a2.77,2.77,0,0,0,4.7,0c.34-.623.355-.76.355-4.972s-.016-4.348-.355-4.972A2.829,2.829,0,0,0,292.585-141.533Z",
    transform: "translate(-7254.797 -3689.002) rotate(180)",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M292.585-141.533a2.618,2.618,0,0,0-1.73,1.277c-.34.623-.355.76-.355,4.972s.016,4.348.355,4.972a2.77,2.77,0,0,0,4.7,0c.34-.623.355-.76.355-4.972s-.016-4.348-.355-4.972A2.829,2.829,0,0,0,292.585-141.533Z",
    transform: "matrix(-0.719, -0.695, 0.695, -0.719, -7272.092, -3455.649)",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M292.585-141.533a2.618,2.618,0,0,0-1.73,1.277c-.34.623-.355.76-.355,4.972s.016,4.348.355,4.972a2.77,2.77,0,0,0,4.7,0c.34-.623.355-.76.355-4.972s-.016-4.348-.355-4.972A2.829,2.829,0,0,0,292.585-141.533Z",
    transform: "matrix(-0.07, -0.998, 0.998, -0.07, -7431.04, -3309.261)",
    fill: "#fdb813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M292.585-141.533a2.618,2.618,0,0,0-1.73,1.277c-.34.623-.355.76-.355,4.972s.016,4.348.355,4.972a2.77,2.77,0,0,0,4.7,0c.34-.623.355-.76.355-4.972s-.016-4.348-.355-4.972A2.829,2.829,0,0,0,292.585-141.533Z",
    transform: "matrix(0.719, -0.695, 0.695, 0.719, -7693.392, -3318.448)",
    fill: "#fdb813"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.9f8082fe5e3806179cc2983a4f6b345a.svg";
export { ForwardRef as ReactComponent };